
import React, { useState, useCallback, useMemo, useRef } from 'react';
import { Popover } from 'devextreme-react/popover';
import './style-banner.css';
import { Button, ButtonTypes } from 'devextreme-react/button';

class App extends React.Component {
    constructor(props) {
        super(props);

        this.onOpenModello = this.onOpenModello.bind(this);        
    }

    render() {

        return (
            <div id="rcorners2" class="header">
                <p>Necessario caricare un file da un modello base :
                    <a id="linkWarning" onClick={this.onOpenModello} href="javascript:void(0);"><font color="white"> Clicca qui per scaricare</font></a>
                </p>
            

            </div>
        )
    }

    onOpenModello = (e) => {
        this.props.onClick(this.props.formData);
    };
}

export default App;